export const MEGA_MENU_CLOSE_EVENT = "mq:mega-menu-close";

export const requestMegaMenuClose = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(MEGA_MENU_CLOSE_EVENT));
};
